import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotConversation } from 'models/copilot/copilotConversation';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';

export class CopilotProcessSuggestion {
  processId?: number;

  parentProcessId?: number;

  uniqueCode: string;

  state?: string;

  name: string;

  description?: string;

  constructor() {
    this.uniqueCode = '';
    this.name = '';
  }

  clone(): CopilotProcessSuggestion {
    const clone = new CopilotProcessSuggestion();
    clone.processId = this.processId;
    clone.parentProcessId = this.parentProcessId;
    clone.uniqueCode = this.uniqueCode;
    clone.state = this.state;
    clone.name = this.name;
    clone.description = this.description;

    return clone;
  }
}

export class TenantProcessStateProcessSuggestions {
  processes: CopilotProcessSuggestion[];

  currentProcesses: CopilotProcessSuggestion[];

  createdProcesses: CopilotProcessSuggestion[];

  conversation: CopilotConversation;

  constructor() {
    this.processes = [];
    this.currentProcesses = [];
    this.createdProcesses = [];
    this.conversation = new CopilotConversation();
  }
}

export class TenantProcessStateProcessSuggestionsDTO {
  processes: CopilotProcessSuggestion[];

  currentProcesses: CopilotProcessSuggestion[];

  createdProcesses: CopilotProcessSuggestion[];

  conversation: CopilotConversationDTO;

  constructor() {
    this.processes = [];
    this.currentProcesses = [];
    this.createdProcesses = [];
    this.conversation = new CopilotConversationDTO();
  }
}

export class CopilotProcessSuggestionsContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.Processes;

  currentProcesses: CopilotProcessSuggestion[];

  constructor(currentProcesses: CopilotProcessSuggestion[]) {
    super();
    this.currentProcesses = currentProcesses;
  }
}
